import styled from "styled-components";

export const LeverageBanner = styled.a`
  cursor: pointer;
  border-radius: var(--rounding-radius-xl, 24px);
  background: var(--fill-secondary, rgba(204, 187, 184, 0.16));
  padding: var(--spacing-space-16, 16px) var(--spacing-space-24, 24px)
    var(--spacing-space-16, 16px) var(--spacing-space-16, 16px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: fit-content;
  margin: 0 auto;
  & > div {
    display: flex;
    align-items: center;
    gap: 12px;
    padding-right: 64px;
    @media (max-width: 1024px) {
      padding-right: 0;
    }
  }

  @media (max-width: 1024px) {
    gap: 8px;
    & > div {
      @media (max-width: 1024px) {
        padding-right: 0;
      }
    }
  }
`;

export const BannerIconWrapper = styled.div`
  height: 48px;
  width: 48px;
  min-width: 48px;
  border-radius: 8px;
  background: #ffc15129;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SignInRow = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  width: 100%;
  gap: 18px;
  & > a {
    width: fit-content;
  }

  @media (min-width: 1024px) {
    flex-direction: row-reverse;
    align-items: center;
    justify-content: flex-end;
    margin-top: auto;
    gap: 30px;
  }
`;
